import { render, staticRenderFns } from "./CardIconInformation.vue?vue&type=template&id=4bf69b48&"
import script from "./CardIconInformation.vue?vue&type=script&lang=js&"
export * from "./CardIconInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports